import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import { useNavigate } from "react-router-dom";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import styled from "styled-components";
import PretendardText from "../../../component/atoms/text/pretendardText";
import MainInput from "./../../../component/atoms/input/mainInput";
import DateInput from "./../../../component/atoms/input/dateInput";
import Checkbox from "./../../../component/atoms/input/checkbox";
import Radio from "./../../../component/atoms/input/radio";
import ImgPreviewLarge from "../../../component/molecules/imgPreviewLarge";
import ImgInputLarge from "../../../component/atoms/input/imgInputLarge";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import { route } from "../../../router/route";
import BoardApi from "../../../api/board.api";
import CategoryApi from "../../../api/category.api";
import FileApi from "../../../api/file.api";
import PopupApi from "../../../api/popup.api";

const OperationPopupBannerCreate = () => {
  const navigate = useNavigate();

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    getKnowledgeStoreMainCategoryList();
    getCommunityMainCategoryList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 지식상점 메인 카테고리 관련 ---------- //
  const [knowledgeStoreMainCategoryList, setKnowledgeStoreMainCategoryList] =
    useState([]);

  const getKnowledgeStoreMainCategoryList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        sort: "orderNumber",
        orderBy: "ASC",
      };

      const response = (await CategoryApi.getListMain(data)).data.data.content;

      const processedResponse = [
        ...response.map((item) => {
          return {
            id: item.id,
            title: item.title,
            checked: false,
          };
        }),
      ];

      setKnowledgeStoreMainCategoryList(processedResponse);
    } catch (error) {
      console.error(error);
    }
  };

  // ---------- 커뮤니티 카테고리 관련 ---------- //
  const [communitySubCategoryList, setCommunitySubCategoryList] = useState([]);

  const getCommunityMainCategoryList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        sort: "orderNumber",
        orderBy: "ASC",
      };

      const response = (await BoardApi.getListMain(data)).data.data.content;

      const processedResponse = response.map((item) => {
        return {
          boardSubCategoryList: [
            ...item.boardSubCategoryList.map((subItem) => {
              return {
                id: subItem.id,
                title: subItem.title,
                checked: false,
              };
            }),
          ],
          id: item.id,
          title: item.title,
          checked: false,
        };
      });

      const subCategoryList = processedResponse.map((item) => {
        return item.boardSubCategoryList;
      });

      setCommunitySubCategoryList(subCategoryList);
    } catch (error) {
      console.error(error);
    }
  };

  // ---------- 입력 값 관련 --------- //
  const [exposeTitle, setExposeTitle] = useState([]);
  const [exposeExcludeBoardTypeList, setExposeExcludeBoardTypeList] = useState(
    []
  );
  const [exposeBoardCategoryIdList, setExposeBoardCategoryIdList] = useState(
    []
  );
  const [exposeBoardSubCategoryIdList, setExposeBoardSubCategoryIdList] =
    useState([]);
  const [exposeMerchCategoryIdList, setExposeMerchCategoryIdList] = useState(
    []
  );

  // 카테고리로 존재하지 않는 나머지 애들은 excludeBoardTypeList로 추가한다.
  // [ MEMBER_HOME(랜딩), SECRET_QNA(멤버십 QnA), SHOP_HOME(지식상점 홈), VU(Vu:), CURRICULUM(커리큘럼), COMMUNITY_HOME(커뮤니티 홈), CREW_GUIDE(멤버십 가이드), WRITING_LINK(라이팅링크), ARCHIVE(자료창고) ]
  const initialInputValue = {
    // 제목
    title: "",
    // 기간
    startDate: "", // 시작일
    endDate: "", // 종료일
    isInfinity: false, // 기간 제한 없음
    // 대상 기기
    deviceType: {
      pc: false,
      mobile: false,
    },
    // 노출 페이지
    exposurePage: {
      home: false, // 라이팅크루 홈 (메인랜딩, 회원랜딩)
      secret: false, // 멤버십 QnA
      store: {
        home: false, // 지식상점 홈
        vu: false, // Vu:
        // 이 외에는 api로 받아온다.
        curriculum: false, // 커리큘럼
      },
      community: {
        home: false, // 커뮤니티 홈
        follow: false, // 팔로우
        // 이 외에는 api로 받아온다.
      },
      crew: {
        guide: false, // 멤버십 가이드
        link: false, // 라이팅링크
        dataStorage: false, // 자료창고
      },
    },
    // 위치/형태
    locationType: {
      popupLayer: true,
      topBanner: false,
    },
    // 이미지 연결링크
    link: "",
    newTab: false, // 새 창에서 열기
  };

  const [inputValue, setInputValue] = useState(initialInputValue);

  // 기간 제한 없음 체크 시 종료일을 9999-12-31로 설정
  useEffect(() => {
    if (inputValue.isInfinity) {
      setInputValue({
        ...inputValue,
        endDate: "9999-12-31",
      });
    } else {
      setInputValue({
        ...inputValue,
        endDate: "",
      });
    }
  }, [inputValue.isInfinity]); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 이미지 관련 --------- //
  const [imageObj, setImageObj] = useState({
    file: "",
    fileUrl: "",
    fileName: "",
  });

  const inputFile = (e) => {
    const file = e.target.files[0];

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = (value) => {
      setImageObj({
        ...imageObj,
        file: file,
        fileUrl: value.target.result,
        fileName: file.name,
      });
    };

    e.target.value = "";
  };

  const deleteFile = () => {
    setImageObj({
      file: "",
      fileUrl: "",
      fileName: "",
    });
  };

  // ---------- 저장하기 ---------- //
  const createPopup = async () => {
    if (!inputValue.title) {
      toast("제목을 입력해 주세요.");
      return;
    } else if (!inputValue.startDate) {
      toast("시작일을 입력해 주세요.");
      return;
    } else if (!inputValue.endDate) {
      toast("종료일을 입력해 주세요.");
      return;
    } else if (!inputValue.deviceType.pc && !inputValue.deviceType.mobile) {
      toast("대상 기기를 선택해 주세요.");
      return;
    } else if (
      exposeTitle.length === 0 &&
      exposeExcludeBoardTypeList.length === 0 &&
      exposeBoardCategoryIdList.length === 0 &&
      exposeBoardSubCategoryIdList.length === 0 &&
      exposeMerchCategoryIdList.length === 0
    ) {
      toast("노출 페이지를 선택해 주세요.");
      return;
    } else if (inputValue.locationType.popupLayer && !imageObj.file) {
      toast("이미지를 업로드해 주세요.");
      return;
    } else if (!inputValue.link) {
      toast("연결링크를 입력해 주세요.");
      return;
    }

    try {
      let imageResponse;
      if (inputValue.locationType.popupLayer) {
        imageResponse = await FileApi.fileUpload(imageObj.file, "admin/popup");
      }

      const sortedExposeTitle = exposeTitle.sort((a, b) => a.localeCompare(b));
      const sortedExposeExcludeBoardTypeList = exposeExcludeBoardTypeList.sort(
        (a, b) => a.localeCompare(b)
      );
      const sortedExposeBoardCategoryIdList = exposeBoardCategoryIdList.sort(
        (a, b) => a - b
      );
      const sortedExposeBoardSubCategoryIdList =
        exposeBoardSubCategoryIdList.sort((a, b) => a - b);
      const sortedExposeMerchCategoryIdList = exposeMerchCategoryIdList.sort(
        (a, b) => a - b
      );

      const data = {
        title: inputValue.title,
        startDate: inputValue.startDate,
        endDate: inputValue.endDate,
        deviceType: [],
        locationPopup: inputValue.locationType.popupLayer,
        imageOriginFileName: imageObj.fileName,
        imageServerFileName: imageResponse
          ? imageResponse.data.data.serverFileName
          : "",
        link: inputValue.link,
        newOpen: inputValue.newTab,
        exposeTitle: sortedExposeTitle.join(", "),
        exposeExcludeBoardTypeList: sortedExposeExcludeBoardTypeList,
        exposeBoardCategoryIdList: sortedExposeBoardCategoryIdList,
        exposeBoardSubCategoryIdList: sortedExposeBoardSubCategoryIdList,
        exposeMerchCategoryIdList: sortedExposeMerchCategoryIdList,
      };

      if (inputValue.deviceType.pc) {
        data.deviceType.push("PC");
      }
      if (inputValue.deviceType.mobile) {
        data.deviceType.push("MO");
      }

      await PopupApi.createPopup(data);
      toast(toastMsg.create);
      navigate(route.operation_popup_banner);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>팝업/배너 추가</TableTitle>
          {/* 제목 영역 */}
          <PopupBannerInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <PopupBannerInputTitle>제목</PopupBannerInputTitle>
            <MainInput
              type={"text"}
              placeholder={"내용을 입력해 주세요."}
              style={{ width: "572px" }}
              value={inputValue.title}
              onChange={(e) => {
                setInputValue({ ...inputValue, title: e.target.value });
              }}
            />
          </PopupBannerInputWrapper>

          {/* 기간 영역 */}
          <PopupBannerInputWrapper
            style={{
              padding: "21px 0px",
              alignItems: "flex-start",
            }}
          >
            <PopupBannerInputTitle>기간</PopupBannerInputTitle>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <DateInput
                  value={inputValue.startDate}
                  onChange={(e) => {
                    setInputValue({ ...inputValue, startDate: e.target.value });
                  }}
                />
                <span
                  style={{
                    width: 6,
                    height: 1,
                    backgroundColor: "rgba(181, 181, 181, 0.5)",
                  }}
                />
                <DateInput
                  value={inputValue.endDate}
                  disabled={inputValue.isInfinity}
                  onChange={(e) => {
                    setInputValue({ ...inputValue, endDate: e.target.value });
                  }}
                />
              </div>
              <CheckboxWrapper>
                <Checkbox
                  style={{
                    backgroundColor: "transparent",
                  }}
                  checked={inputValue.isInfinity}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      isInfinity: e.target.checked,
                    });
                  }}
                />
                <CheckboxText
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    lineHeight: "21.5px",
                    color: "#aaa",
                  }}
                >
                  기간 제한 없음
                </CheckboxText>
              </CheckboxWrapper>
            </div>
          </PopupBannerInputWrapper>

          {/* 대상 기기 영역 */}
          <PopupBannerInputWrapper
            style={{
              padding: "21px 0px",
              height: 90,
            }}
          >
            <PopupBannerInputTitle>대상 기기</PopupBannerInputTitle>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 22,
              }}
            >
              <CheckboxWrapper>
                <Checkbox
                  style={{
                    backgroundColor: "transparent",
                  }}
                  checked={inputValue.deviceType.pc}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      deviceType: {
                        ...inputValue.deviceType,
                        pc: e.target.checked,
                      },
                    });
                  }}
                />
                <CheckboxText
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    lineHeight: "21.5px",
                    color: "#aaa",
                  }}
                >
                  PC
                </CheckboxText>
              </CheckboxWrapper>
              <CheckboxWrapper>
                <Checkbox
                  style={{
                    backgroundColor: "transparent",
                  }}
                  checked={inputValue.deviceType.mobile}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      deviceType: {
                        ...inputValue.deviceType,
                        mobile: e.target.checked,
                      },
                    });
                  }}
                />
                <CheckboxText
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    lineHeight: "21.5px",
                    color: "#aaa",
                  }}
                >
                  모바일
                </CheckboxText>
              </CheckboxWrapper>
            </div>
          </PopupBannerInputWrapper>

          {/* 노출 페이지 영역 */}
          <PopupBannerInputWrapper
            style={{
              flexDirection: "column",
              alignItems: "flex-start",
              padding: "21px 0px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              <PopupBannerInputTitle>노출 페이지</PopupBannerInputTitle>
              <PretendardText
                style={{
                  fontWeight: "500",
                  fontSize: "13px",
                  lineHeight: "18.75px",
                  color: "rgba(181, 181, 181, 0.5)",
                  marginTop: 6,
                }}
              >
                지정한 카테고리에 팝업/배너가 노출됩니다 (다중 선택 가능)
              </PretendardText>
            </div>

            {/* 홈 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              <PopupBannerInputTitle>홈</PopupBannerInputTitle>
              <CheckboxWrapper
                style={{
                  marginTop: 5,
                }}
              >
                <Checkbox
                  checked={inputValue.exposurePage.home}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setExposeTitle([
                        ...exposeTitle,
                        "라이팅크루 홈 (메인랜딩, 회원랜딩)",
                      ]);
                      setExposeExcludeBoardTypeList([
                        ...exposeExcludeBoardTypeList,
                        "MEMBER_HOME",
                      ]);
                    } else {
                      setExposeTitle(
                        exposeTitle.filter(
                          (item) =>
                            item !== "라이팅크루 홈 (메인랜딩, 회원랜딩)"
                        )
                      );
                      setExposeExcludeBoardTypeList(
                        exposeExcludeBoardTypeList.filter(
                          (item) => item !== "MEMBER_HOME"
                        )
                      );
                    }

                    setInputValue({
                      ...inputValue,
                      exposurePage: {
                        ...inputValue.exposurePage,
                        home: e.target.checked,
                      },
                    });
                  }}
                />
                <CheckboxText>라이팅크루 홈 (메인랜딩, 회원랜딩)</CheckboxText>
              </CheckboxWrapper>
            </div>

            {/* 일급비밀 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              <PopupBannerInputTitle>일급비밀</PopupBannerInputTitle>
              <CheckboxWrapper
                style={{
                  marginTop: 5,
                }}
              >
                <Checkbox
                  checked={inputValue.exposurePage.secret}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setExposeTitle([...exposeTitle, "멤버십 QnA"]);
                      setExposeExcludeBoardTypeList([
                        ...exposeExcludeBoardTypeList,
                        "SECRET_QNA",
                      ]);
                    } else {
                      setExposeTitle(
                        exposeTitle.filter((item) => item !== "멤버십 QnA")
                      );
                      setExposeExcludeBoardTypeList(
                        exposeExcludeBoardTypeList.filter(
                          (item) => item !== "SECRET_QNA"
                        )
                      );
                    }

                    setInputValue({
                      ...inputValue,
                      exposurePage: {
                        ...inputValue.exposurePage,
                        secret: e.target.checked,
                      },
                    });
                  }}
                />
                <CheckboxText>멤버십 QnA</CheckboxText>
              </CheckboxWrapper>
            </div>

            {/* 지식상점 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              <PopupBannerInputTitle>지식상점</PopupBannerInputTitle>
              <CheckboxListWrapper
                style={{
                  marginTop: 5,
                }}
              >
                <CheckboxWrapper>
                  <Checkbox
                    checked={inputValue.exposurePage.store.home}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setExposeTitle([...exposeTitle, "지식상점 홈"]);
                        setExposeExcludeBoardTypeList([
                          ...exposeExcludeBoardTypeList,
                          "SHOP_HOME",
                        ]);
                      } else {
                        setExposeTitle(
                          exposeTitle.filter((item) => item !== "지식상점 홈")
                        );
                        setExposeExcludeBoardTypeList(
                          exposeExcludeBoardTypeList.filter(
                            (item) => item !== "SHOP_HOME"
                          )
                        );
                      }

                      setInputValue({
                        ...inputValue,
                        exposurePage: {
                          ...inputValue.exposurePage,
                          store: {
                            ...inputValue.exposurePage.store,
                            home: e.target.checked,
                          },
                        },
                      });
                    }}
                  />
                  <CheckboxText>지식상점 홈</CheckboxText>
                </CheckboxWrapper>
                <CheckboxWrapper>
                  <Checkbox
                    checked={inputValue.exposurePage.store.vu}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setExposeTitle([...exposeTitle, "Vu:"]);
                        setExposeExcludeBoardTypeList([
                          ...exposeExcludeBoardTypeList,
                          "VU",
                        ]);
                      } else {
                        setExposeTitle(
                          exposeTitle.filter((item) => item !== "Vu:")
                        );
                        setExposeExcludeBoardTypeList(
                          exposeExcludeBoardTypeList.filter(
                            (item) => item !== "VU"
                          )
                        );
                      }

                      setInputValue({
                        ...inputValue,
                        exposurePage: {
                          ...inputValue.exposurePage,
                          store: {
                            ...inputValue.exposurePage.store,
                            vu: e.target.checked,
                          },
                        },
                      });
                    }}
                  />
                  <CheckboxText>Vu:</CheckboxText>
                </CheckboxWrapper>
                {knowledgeStoreMainCategoryList.map((item, index) => {
                  return (
                    <CheckboxWrapper key={index}>
                      <Checkbox
                        checked={
                          inputValue.exposurePage.store[item.title] || false
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            setExposeTitle([...exposeTitle, item.title]);
                            setExposeMerchCategoryIdList([
                              ...exposeMerchCategoryIdList,
                              item.id,
                            ]);
                          } else {
                            setExposeTitle(
                              exposeTitle.filter(
                                (title) => title !== item.title
                              )
                            );
                            setExposeMerchCategoryIdList(
                              exposeMerchCategoryIdList.filter(
                                (id) => id !== item.id
                              )
                            );
                          }

                          setInputValue({
                            ...inputValue,
                            exposurePage: {
                              ...inputValue.exposurePage,
                              store: {
                                ...inputValue.exposurePage.store,
                                [item.title]: e.target.checked,
                              },
                            },
                          });
                        }}
                      />
                      <CheckboxText>{item.title}</CheckboxText>
                    </CheckboxWrapper>
                  );
                })}
                <CheckboxWrapper>
                  <Checkbox
                    checked={inputValue.exposurePage.store.curriculum}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setExposeTitle([...exposeTitle, "커리큘럼"]);
                        setExposeExcludeBoardTypeList([
                          ...exposeExcludeBoardTypeList,
                          "CURRICULUM",
                        ]);
                      } else {
                        setExposeTitle(
                          exposeTitle.filter((item) => item !== "커리큘럼")
                        );
                        setExposeExcludeBoardTypeList(
                          exposeExcludeBoardTypeList.filter(
                            (item) => item !== "CURRICULUM"
                          )
                        );
                      }

                      setInputValue({
                        ...inputValue,
                        exposurePage: {
                          ...inputValue.exposurePage,
                          store: {
                            ...inputValue.exposurePage.store,
                            curriculum: e.target.checked,
                          },
                        },
                      });
                    }}
                  />
                  <CheckboxText>커리큘럼</CheckboxText>
                </CheckboxWrapper>
              </CheckboxListWrapper>
            </div>

            {/* 커뮤니티 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              <PopupBannerInputTitle>커뮤니티</PopupBannerInputTitle>
              <CheckboxWrapper
                style={{
                  marginTop: 5,
                  marginBottom: 10,
                }}
              >
                <Checkbox
                  checked={inputValue.exposurePage.community.home}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setExposeTitle([...exposeTitle, "커뮤니티 홈"]);
                      setExposeExcludeBoardTypeList([
                        ...exposeExcludeBoardTypeList,
                        "COMMUNITY_HOME",
                      ]);
                    } else {
                      setExposeTitle(
                        exposeTitle.filter((item) => item !== "커뮤니티 홈")
                      );
                      setExposeExcludeBoardTypeList(
                        exposeExcludeBoardTypeList.filter(
                          (item) => item !== "COMMUNITY_HOME"
                        )
                      );
                    }

                    setInputValue({
                      ...inputValue,
                      exposurePage: {
                        ...inputValue.exposurePage,
                        community: {
                          ...inputValue.exposurePage.community,
                          home: e.target.checked,
                        },
                      },
                    });
                  }}
                />
                <CheckboxText>커뮤니티 홈</CheckboxText>
              </CheckboxWrapper>
              <CheckboxWrapper
                style={{
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <Checkbox
                  checked={inputValue.exposurePage.community.follow}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setExposeTitle([...exposeTitle, "팔로우"]);
                      setExposeBoardCategoryIdList([
                        ...exposeBoardCategoryIdList,
                        2,
                      ]);
                    } else {
                      setExposeTitle(
                        exposeTitle.filter((item) => item !== "팔로우")
                      );
                      setExposeBoardCategoryIdList(
                        exposeBoardCategoryIdList.filter((id) => id !== 2)
                      );
                    }

                    setInputValue({
                      ...inputValue,
                      exposurePage: {
                        ...inputValue.exposurePage,
                        community: {
                          ...inputValue.exposurePage.community,
                          follow: e.target.checked,
                        },
                      },
                    });
                  }}
                />
                <CheckboxText>팔로우</CheckboxText>
              </CheckboxWrapper>

              <CheckboxListWrapper
                style={{
                  marginTop: 10,
                }}
              >
                {communitySubCategoryList.map((subItem, subIndex) =>
                  subItem.map((item, index) => {
                    return (
                      <CheckboxWrapper key={index}>
                        <Checkbox
                          checked={
                            inputValue.exposurePage.community[item.title] ||
                            false
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setExposeTitle([...exposeTitle, item.title]);
                              setExposeBoardSubCategoryIdList([
                                ...exposeBoardSubCategoryIdList,
                                item.id,
                              ]);
                            } else {
                              setExposeTitle(
                                exposeTitle.filter(
                                  (title) => title !== item.title
                                )
                              );
                              setExposeBoardSubCategoryIdList(
                                exposeBoardSubCategoryIdList.filter(
                                  (id) => id !== item.id
                                )
                              );
                            }

                            setInputValue({
                              ...inputValue,
                              exposurePage: {
                                ...inputValue.exposurePage,
                                community: {
                                  ...inputValue.exposurePage.community,
                                  [item.title]: e.target.checked,
                                },
                              },
                            });
                          }}
                        />
                        <CheckboxText>{item.title}</CheckboxText>
                      </CheckboxWrapper>
                    );
                  })
                )}
              </CheckboxListWrapper>
            </div>

            {/* 크루전용 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              <PopupBannerInputTitle>크루전용</PopupBannerInputTitle>
              <CheckboxListWrapper
                style={{
                  marginTop: 5,
                }}
              >
                <CheckboxWrapper>
                  <Checkbox
                    checked={inputValue.exposurePage.crew.guide}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setExposeTitle([...exposeTitle, "멤버십 가이드"]);
                        setExposeExcludeBoardTypeList([
                          ...exposeExcludeBoardTypeList,
                          "CREW_GUIDE",
                        ]);
                      } else {
                        setExposeTitle(
                          exposeTitle.filter((item) => item !== "멤버십 가이드")
                        );
                        setExposeExcludeBoardTypeList(
                          exposeExcludeBoardTypeList.filter(
                            (item) => item !== "CREW_GUIDE"
                          )
                        );
                      }

                      setInputValue({
                        ...inputValue,
                        exposurePage: {
                          ...inputValue.exposurePage,
                          crew: {
                            ...inputValue.exposurePage.crew,
                            guide: e.target.checked,
                          },
                        },
                      });
                    }}
                  />
                  <CheckboxText>멤버십 가이드</CheckboxText>
                </CheckboxWrapper>
                <CheckboxWrapper>
                  <Checkbox
                    checked={inputValue.exposurePage.crew.link}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setExposeTitle([...exposeTitle, "라이팅링크"]);
                        setExposeExcludeBoardTypeList([
                          ...exposeExcludeBoardTypeList,
                          "WRITING_LINK",
                        ]);
                      } else {
                        setExposeTitle(
                          exposeTitle.filter((item) => item !== "라이팅링크")
                        );
                        setExposeExcludeBoardTypeList(
                          exposeExcludeBoardTypeList.filter(
                            (item) => item !== "WRITING_LINK"
                          )
                        );
                      }

                      setInputValue({
                        ...inputValue,
                        exposurePage: {
                          ...inputValue.exposurePage,
                          crew: {
                            ...inputValue.exposurePage.crew,
                            link: e.target.checked,
                          },
                        },
                      });
                    }}
                  />
                  <CheckboxText>라이팅링크</CheckboxText>
                </CheckboxWrapper>
                <CheckboxWrapper>
                  <Checkbox
                    checked={inputValue.exposurePage.crew.dataStorage}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setExposeTitle([...exposeTitle, "자료창고"]);
                        setExposeExcludeBoardTypeList([
                          ...exposeExcludeBoardTypeList,
                          "ARCHIVE",
                        ]);
                      } else {
                        setExposeTitle(
                          exposeTitle.filter((item) => item !== "자료창고")
                        );
                        setExposeExcludeBoardTypeList(
                          exposeExcludeBoardTypeList.filter(
                            (item) => item !== "ARCHIVE"
                          )
                        );
                      }

                      setInputValue({
                        ...inputValue,
                        exposurePage: {
                          ...inputValue.exposurePage,
                          crew: {
                            ...inputValue.exposurePage.crew,
                            dataStorage: e.target.checked,
                          },
                        },
                      });
                    }}
                  />
                  <CheckboxText>자료창고</CheckboxText>
                </CheckboxWrapper>
              </CheckboxListWrapper>
            </div>
          </PopupBannerInputWrapper>

          {/* 위치/형태 영역 */}
          <PopupBannerInputWrapper
            style={{
              padding: "21px 0px",
              height: 90,
            }}
          >
            <PopupBannerInputTitle>위치/형태</PopupBannerInputTitle>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 20,
              }}
            >
              <Radio
                id={"popupLayer"}
                valueText={"팝업 레이어"}
                checked={inputValue.locationType.popupLayer}
                onChange={() => {
                  setInputValue({
                    ...inputValue,
                    locationType: {
                      popupLayer: true,
                      topBanner: false,
                    },
                  });
                }}
              />
              <Radio
                id={"topBanner"}
                valueText={"상단 배너"}
                checked={inputValue.locationType.topBanner}
                onChange={() => {
                  setInputValue({
                    ...inputValue,
                    locationType: {
                      popupLayer: false,
                      topBanner: true,
                    },
                  });
                }}
              />
            </div>
          </PopupBannerInputWrapper>

          {/* 위치/형태 영역 */}
          {inputValue.locationType.popupLayer && (
            <PopupBannerInputWrapper
              style={{
                padding: "21px 0px",
                alignItems: "flex-start",
              }}
            >
              <PopupBannerInputTitle>이미지</PopupBannerInputTitle>
              <div
                style={{
                  width: 254,
                  height: "fit-content",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {imageObj.fileUrl ? (
                  <ImgPreviewLarge
                    fileUrl={imageObj.fileUrl}
                    onClick={() => {
                      deleteFile();
                    }}
                  />
                ) : (
                  <ImgInputLarge
                    id={"file"}
                    accept={"image/*"}
                    onChange={(e) => {
                      inputFile(e);
                    }}
                  />
                )}
              </div>
            </PopupBannerInputWrapper>
          )}

          {/* 연결링크 영역 */}
          <PopupBannerInputWrapper
            style={{
              padding: "21px 0px",
              alignItems: "flex-start",
            }}
          >
            <PopupBannerInputTitle>연결링크</PopupBannerInputTitle>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <MainInput
                type={"text"}
                placeholder={"https://www.example.com"}
                style={{ width: "572px" }}
                value={inputValue.link}
                onChange={(e) => {
                  setInputValue({ ...inputValue, link: e.target.value });
                }}
              />

              <CheckboxWrapper>
                <Checkbox
                  style={{
                    backgroundColor: "transparent",
                  }}
                  checked={inputValue.newTab}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      newTab: e.target.checked,
                    });
                  }}
                />
                <CheckboxText>새 창에서 열기</CheckboxText>
              </CheckboxWrapper>
            </div>
          </PopupBannerInputWrapper>

          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            {/* <BasicBtn isBlue={true} onClick={() => {}}>
              미리보기
            </BasicBtn> */}
            <BasicBtn onClick={createPopup}>저장하기</BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default OperationPopupBannerCreate;

const PopupBannerInputWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
`;

const PopupBannerInputTitle = styled(PretendardText).attrs((props) => {})`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;
`;

const CheckboxListWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 5px;
`;
